import { render } from "./TextAreaRow.vue?vue&type=template&id=acda0652"
import script from "./TextAreaRow.vue?vue&type=script&lang=js"
export * from "./TextAreaRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__